import { Component } from '@angular/core';
import { SubProductDetails } from '../../../../components/admin-dashboard-component/product-details/product-sub-products/sub-product-details/sub-product-details';

@Component({
  selector: 'app-view-sub-product',
  imports: [SubProductDetails],
  templateUrl: './view-sub-product.html',
  styleUrl: './view-sub-product.scss',
})
export class ViewSubProduct {}
